import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { VehicleAllocationEnum } from '../enums/vehicle-allocation.enum';
import { VehicleBodyTypeEnum } from '../enums/vehicle-body-type.enum';
import { VehicleFuelTypeEnum } from '../enums/vehicle-fuel-type.enum';
import { VehicleMovementDirectionEnum } from '../enums/vehicle-movement-direction.enum';
import { VehicleTypeEnum } from '../enums/vehicle-type.enum';

/**
 * Vehicles movement filters
 */
export class VehiclesMovementFilters extends ApiRequestFilters {
	/**
	 * Movement direction
	 */
	direction?: VehicleMovementDirectionEnum;

	/**
	 * Date from
	 */
	dateFrom?: Date;

	/**
	 * Date to
	 */
	dateTo?: Date;

	/**
	 * Vehicle body type values
	 */
	bodyTypes?: VehicleBodyTypeEnum[];

	/**
	 * Vehicle fuel type values
	 */
	fuelTypes?: VehicleFuelTypeEnum[];

	/**
	 * Vehicle allocation values
	 */
	allocations?: VehicleAllocationEnum[];

	/**
	 * Location id values
	 */
	locations?: number[];

	/**
	 * Vehicle category id values
	 */
	vehicleCategories?: number[];

	/**
	 * Type values
	 */
	types?: VehicleTypeEnum[];

	/**
	 * Tag id values
	 */
	tags?: number[];
}
